(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-blog-featured"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const rightSlider = document.querySelector('.other-articles.swiper');

    if (rightSlider && window.innerWidth <= 767) {
      new Swiper(rightSlider, {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 16,
        loop: false,
        navigation: {
          nextEl: rightSlider.querySelector('.swiper-button-next'),
          prevEl: rightSlider.querySelector('.swiper-button-prev')
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-blog-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const loadMoreButtons = document.querySelectorAll(".load-more-btn");

  loadMoreButtons.forEach((btn) => {
    const sectionId = btn.dataset.sectionId;
    const perClick = parseInt(btn.dataset.count || "2");
    const cardSelector = `.blog-card-${sectionId}.hidden`;

    btn.addEventListener("click", () => {
      const hiddenCards = document.querySelectorAll(cardSelector);
      let shown = 0;

      hiddenCards.forEach((card) => {
        if (shown < perClick) {
          card.classList.remove("hidden");
          shown++;
        }
      });

      if (document.querySelectorAll(cardSelector).length === 0) {
        btn.style.display = "none";
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-kiyoh-banner"] && !Shopify.designMode) return;
  try {
    
fetch('https://kiyoh-reviews.vercel.app/api/kiyoh-reviews')
  .then(res => res.json())
  .then(data => {
    const container = document.getElementById("reviews");

    if (data.reviews && data.reviews.length) {
      const avgRating = data.reviews.reduce((sum, r) => sum + parseFloat(r.rating || 0), 0) / data.reviews.length;
      document.getElementById("avg-score").textContent = avgRating.toFixed(1);
      document.getElementById("review-count").textContent = `${data.reviews.length.toLocaleString('nl-NL')} beoordelingen in de laatste 12 maanden. 90% beveelt ons aan!`;

      container.innerHTML = "";
      data.reviews.forEach((review, index) => {
        const div = document.createElement("div");
        div.className = "review";

        const rating = parseFloat(review.rating || 0);
        const starsOutOf5 = rating / 2;
        const fullStars = Math.floor(starsOutOf5);
        const fractional = starsOutOf5 - fullStars;
        const emptyStars = 5 - Math.ceil(starsOutOf5);
        let starsHTML = '';

        const fullStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M13.482,5.92a14.534,14.534,0,0,0-2.4-5.361,1.311,1.311,0,0,0-2.147,0A14.518,14.518,0,0,0,6.518,5.92a15.258,15.258,0,0,0-5.567.767A1.434,1.434,0,0,0,.243,8.834a13.23,13.23,0,0,0,4.123,4.007,17.443,17.443,0,0,0-1,5.7A1.378,1.378,0,0,0,4.66,20a1.393,1.393,0,0,0,.475-.057A13.47,13.47,0,0,0,10,17.124a13.478,13.478,0,0,0,4.866,2.816,1.377,1.377,0,0,0,1.773-1.393,17.443,17.443,0,0,0-1-5.7,13.23,13.23,0,0,0,4.123-4.007,1.435,1.435,0,0,0-.393-1.989,1.45,1.45,0,0,0-.316-.159,15.258,15.258,0,0,0-5.567-.767Z" fill="#ffc11d"/></svg>`;

        const emptyStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20.001" height="20" viewBox="0 0 20.001 20"><path d="M118.249,6.849a1.45,1.45,0,0,0-.316-.159A15.278,15.278,0,0,0,113.1,5.9c-.244,0-.486.006-.731.018v0a14.517,14.517,0,0,0-2.4-5.361,1.313,1.313,0,0,0-2.147,0A14.518,14.518,0,0,0,105.4,5.92c-.244-.012-.488-.018-.732-.018a15.3,15.3,0,0,0-4.835.785,1.433,1.433,0,0,0-.708,2.148,13.23,13.23,0,0,0,4.123,4.007,17.438,17.438,0,0,0-1,5.7,1.378,1.378,0,0,0,1.3,1.453l.073,0a1.4,1.4,0,0,0,.4-.058,13.491,13.491,0,0,0,4.862-2.816,13.494,13.494,0,0,0,4.866,2.816,1.378,1.378,0,0,0,1.773-1.394,17.437,17.437,0,0,0-1-5.7,13.207,13.207,0,0,0,4.123-4.007,1.435,1.435,0,0,0-.393-1.989m-.5,1.4a12.252,12.252,0,0,1-3.788,3.683,1.073,1.073,0,0,0-.449,1.274,16.442,16.442,0,0,1,.942,5.4.343.343,0,0,1-.013.1.306.306,0,0,1-.291.216.483.483,0,0,1-.067-.005,12.337,12.337,0,0,1-4.479-2.592,1.075,1.075,0,0,0-1.438,0,12.3,12.3,0,0,1-4.451,2.585.344.344,0,0,1-.1.013h0a.322.322,0,0,1-.285-.374,16.319,16.319,0,0,1,.94-5.35,1.073,1.073,0,0,0-.449-1.274,12.26,12.26,0,0,1-3.8-3.693.361.361,0,0,1-.024-.351.347.347,0,0,1,.181-.178,14.2,14.2,0,0,1,4.5-.729q.34,0,.682.017h.052a1.072,1.072,0,0,0,1.046-.84,13.392,13.392,0,0,1,2.242-4.977.29.29,0,0,1,.06-.06.243.243,0,0,1,.135-.043.251.251,0,0,1,.2.113,13.384,13.384,0,0,1,2.219,4.933A1.073,1.073,0,0,0,112.366,7h.052c.226-.011.453-.017.679-.017a14.193,14.193,0,0,1,4.475.722.348.348,0,0,1,.079.041.362.362,0,0,1,.153.229.368.368,0,0,1-.06.278" transform="translate(-100)" fill="#ccc"/></svg>`;

        for (let i = 0; i < fullStars; i++) starsHTML += fullStarSVG;

        if (fractional > 0) {
          const percent = Math.round(fractional * 100);
          starsHTML += `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g id="icon-20-star_half" data-name="icon-20-star half" transform="translate(-206 -2433)">
    <rect id="Rectangle_185" data-name="Rectangle 185" width="20" height="20" transform="translate(206 2433)" fill="none"/>
    <path id="Path_184" data-name="Path 184" d="M93.621,6.849a1.5,1.5,0,0,0-.316-.159A15.289,15.289,0,0,0,88.467,5.9q-.364,0-.731.018v0a14.514,14.514,0,0,0-2.4-5.361A1.31,1.31,0,0,0,83.5.239a1.3,1.3,0,0,0-.246.246A1.286,1.286,0,0,0,83,.749a14.23,14.23,0,0,0-2.338,5.169c-.208-.01-.418-.016-.626-.016a15.3,15.3,0,0,0-4.836.785,1.433,1.433,0,0,0-.927,1.594,1.486,1.486,0,0,0,.042.169c.009.024.01.047.018.071a1.072,1.072,0,0,0,.067.131,1.3,1.3,0,0,0,.088.213,12.945,12.945,0,0,0,4.043,3.93,17.074,17.074,0,0,0-.983,5.586,1.352,1.352,0,0,0,.056.459,1.215,1.215,0,0,0,.071.133A1.362,1.362,0,0,0,78.913,20l.074,0a1.4,1.4,0,0,0,.4-.058,13.508,13.508,0,0,0,4.864-2.816,13.5,13.5,0,0,0,4.867,2.816,1.38,1.38,0,0,0,1.716-.921,1.434,1.434,0,0,0,.057-.473,17.435,17.435,0,0,0-1-5.7,13.2,13.2,0,0,0,4.122-4.007,1.434,1.434,0,0,0-.392-1.989m-.5,1.4a12.253,12.253,0,0,1-3.788,3.683,1.072,1.072,0,0,0-.449,1.274,16.44,16.44,0,0,1,.943,5.4.309.309,0,0,1-.014.1.3.3,0,0,1-.29.216.523.523,0,0,1-.068-.005,12.327,12.327,0,0,1-4.479-2.592,1.073,1.073,0,0,0-.719-.276c-.03,0-.06.013-.09.015a73.545,73.545,0,0,0,.644-7.477,74,74,0,0,0-.644-7.484.214.214,0,0,1,.1-.031.246.246,0,0,1,.2.114,13.356,13.356,0,0,1,2.22,4.932A1.075,1.075,0,0,0,87.736,7h.053c.227-.011.453-.017.678-.017a14.193,14.193,0,0,1,4.475.722.355.355,0,0,1,.081.041.362.362,0,0,1,.154.229.373.373,0,0,1-.06.278" transform="translate(131.744 2433)" fill="#ffc11d"/>
  </g>
</svg>`;
        }

        for (let i = 0; i < emptyStars; i++) starsHTML += emptyStarSVG;

        const content = review.reviewContent
          .filter(q => q.reviewText || q.rating)
          .map(q => {
            if (q.questionTranslation === "Beschrijf uw ervaring" && q.reviewText) {
              return `<p class="review-text"><span class="ervaring-content">${q.reviewText}</span></p>`;
            } else {
              return `<p class="review-text">${q.rating || q.reviewText}</p>`;
            }
          })
          .join('');

        const date = new Date(review.dateSince).toLocaleDateString("nl-NL", {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        div.innerHTML = `
<div class="stars">${starsHTML}<div class="strtxt">Geverifieerd</div></div>
${content}
<div class="author"><div class="author1">${review.reviewAuthor || "Anoniem"}</div><div>${date}</div></div>
<div class="rating-pill">${review.rating || ""}</div>
        `;

        container.appendChild(div);
      });
    } else {
      container.innerHTML = "<p>Geen beoordelingen gevonden.</p>";
    }
  })
  .catch(() => {
    document.getElementById("reviews").innerHTML = "Fout bij laden van beoordelingen.";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-kiyoh-review"] && !Shopify.designMode) return;
  try {
    
fetch('https://kiyoh-reviews.vercel.app/api/kiyoh-reviews')
  .then(res => res.json())
  .then(data => {
    const container = document.getElementById("reviews");

    if (data.reviews && data.reviews.length) {
      const avgRating = data.reviews.reduce((sum, r) => sum + parseFloat(r.rating || 0), 0) / data.reviews.length;
      document.getElementById("avg-score").textContent = avgRating.toFixed(1);
      document.getElementById("review-count").textContent = `${data.reviews.length.toLocaleString('nl-NL')} beoordelingen in de laatste 12 maanden. 90% beveelt ons aan!`;

      container.innerHTML = "";
      data.reviews.forEach((review, index) => {
        const div = document.createElement("div");
        div.className = "review scroll-trigger animate--slide-in";

        const rating = parseFloat(review.rating || 0);
        const starsOutOf5 = rating / 2;
        const fullStars = Math.floor(starsOutOf5);
        const fractional = starsOutOf5 - fullStars;
        const emptyStars = 5 - Math.ceil(starsOutOf5);
        let starsHTML = '';

        const fullStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="M13.482,5.92a14.534,14.534,0,0,0-2.4-5.361,1.311,1.311,0,0,0-2.147,0A14.518,14.518,0,0,0,6.518,5.92a15.258,15.258,0,0,0-5.567.767A1.434,1.434,0,0,0,.243,8.834a13.23,13.23,0,0,0,4.123,4.007,17.443,17.443,0,0,0-1,5.7A1.378,1.378,0,0,0,4.66,20a1.393,1.393,0,0,0,.475-.057A13.47,13.47,0,0,0,10,17.124a13.478,13.478,0,0,0,4.866,2.816,1.377,1.377,0,0,0,1.773-1.393,17.443,17.443,0,0,0-1-5.7,13.23,13.23,0,0,0,4.123-4.007,1.435,1.435,0,0,0-.393-1.989,1.45,1.45,0,0,0-.316-.159,15.258,15.258,0,0,0-5.567-.767Z" fill="#ffc11d"/></svg>`;

        const emptyStarSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="20.001" height="20" viewBox="0 0 20.001 20"><path d="M118.249,6.849a1.45,1.45,0,0,0-.316-.159A15.278,15.278,0,0,0,113.1,5.9c-.244,0-.486.006-.731.018v0a14.517,14.517,0,0,0-2.4-5.361,1.313,1.313,0,0,0-2.147,0A14.518,14.518,0,0,0,105.4,5.92c-.244-.012-.488-.018-.732-.018a15.3,15.3,0,0,0-4.835.785,1.433,1.433,0,0,0-.708,2.148,13.23,13.23,0,0,0,4.123,4.007,17.438,17.438,0,0,0-1,5.7,1.378,1.378,0,0,0,1.3,1.453l.073,0a1.4,1.4,0,0,0,.4-.058,13.491,13.491,0,0,0,4.862-2.816,13.494,13.494,0,0,0,4.866,2.816,1.378,1.378,0,0,0,1.773-1.394,17.437,17.437,0,0,0-1-5.7,13.207,13.207,0,0,0,4.123-4.007,1.435,1.435,0,0,0-.393-1.989m-.5,1.4a12.252,12.252,0,0,1-3.788,3.683,1.073,1.073,0,0,0-.449,1.274,16.442,16.442,0,0,1,.942,5.4.343.343,0,0,1-.013.1.306.306,0,0,1-.291.216.483.483,0,0,1-.067-.005,12.337,12.337,0,0,1-4.479-2.592,1.075,1.075,0,0,0-1.438,0,12.3,12.3,0,0,1-4.451,2.585.344.344,0,0,1-.1.013h0a.322.322,0,0,1-.285-.374,16.319,16.319,0,0,1,.94-5.35,1.073,1.073,0,0,0-.449-1.274,12.26,12.26,0,0,1-3.8-3.693.361.361,0,0,1-.024-.351.347.347,0,0,1,.181-.178,14.2,14.2,0,0,1,4.5-.729q.34,0,.682.017h.052a1.072,1.072,0,0,0,1.046-.84,13.392,13.392,0,0,1,2.242-4.977.29.29,0,0,1,.06-.06.243.243,0,0,1,.135-.043.251.251,0,0,1,.2.113,13.384,13.384,0,0,1,2.219,4.933A1.073,1.073,0,0,0,112.366,7h.052c.226-.011.453-.017.679-.017a14.193,14.193,0,0,1,4.475.722.348.348,0,0,1,.079.041.362.362,0,0,1,.153.229.368.368,0,0,1-.06.278" transform="translate(-100)" fill="#ccc"/></svg>`;

        for (let i = 0; i < fullStars; i++) starsHTML += fullStarSVG;

        if (fractional > 0) {
          const percent = Math.round(fractional * 100);
          starsHTML += `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <g id="icon-20-star_half" data-name="icon-20-star half" transform="translate(-206 -2433)">
    <rect id="Rectangle_185" data-name="Rectangle 185" width="20" height="20" transform="translate(206 2433)" fill="none"/>
    <path id="Path_184" data-name="Path 184" d="M93.621,6.849a1.5,1.5,0,0,0-.316-.159A15.289,15.289,0,0,0,88.467,5.9q-.364,0-.731.018v0a14.514,14.514,0,0,0-2.4-5.361A1.31,1.31,0,0,0,83.5.239a1.3,1.3,0,0,0-.246.246A1.286,1.286,0,0,0,83,.749a14.23,14.23,0,0,0-2.338,5.169c-.208-.01-.418-.016-.626-.016a15.3,15.3,0,0,0-4.836.785,1.433,1.433,0,0,0-.927,1.594,1.486,1.486,0,0,0,.042.169c.009.024.01.047.018.071a1.072,1.072,0,0,0,.067.131,1.3,1.3,0,0,0,.088.213,12.945,12.945,0,0,0,4.043,3.93,17.074,17.074,0,0,0-.983,5.586,1.352,1.352,0,0,0,.056.459,1.215,1.215,0,0,0,.071.133A1.362,1.362,0,0,0,78.913,20l.074,0a1.4,1.4,0,0,0,.4-.058,13.508,13.508,0,0,0,4.864-2.816,13.5,13.5,0,0,0,4.867,2.816,1.38,1.38,0,0,0,1.716-.921,1.434,1.434,0,0,0,.057-.473,17.435,17.435,0,0,0-1-5.7,13.2,13.2,0,0,0,4.122-4.007,1.434,1.434,0,0,0-.392-1.989m-.5,1.4a12.253,12.253,0,0,1-3.788,3.683,1.072,1.072,0,0,0-.449,1.274,16.44,16.44,0,0,1,.943,5.4.309.309,0,0,1-.014.1.3.3,0,0,1-.29.216.523.523,0,0,1-.068-.005,12.327,12.327,0,0,1-4.479-2.592,1.073,1.073,0,0,0-.719-.276c-.03,0-.06.013-.09.015a73.545,73.545,0,0,0,.644-7.477,74,74,0,0,0-.644-7.484.214.214,0,0,1,.1-.031.246.246,0,0,1,.2.114,13.356,13.356,0,0,1,2.22,4.932A1.075,1.075,0,0,0,87.736,7h.053c.227-.011.453-.017.678-.017a14.193,14.193,0,0,1,4.475.722.355.355,0,0,1,.081.041.362.362,0,0,1,.154.229.373.373,0,0,1-.06.278" transform="translate(131.744 2433)" fill="#ffc11d"/>
  </g>
</svg>`;
        }

        for (let i = 0; i < emptyStars; i++) starsHTML += emptyStarSVG;

        const content = review.reviewContent
          .filter(q => q.reviewText || q.rating)
          .map(q => {
            if (q.questionTranslation === "Beschrijf uw ervaring" && q.reviewText) {
              return `<p class="review-text"><span class="ervaring-content">${q.reviewText}</span></p>`;
            } else {
              return `<p class="review-text">${q.rating || q.reviewText}</p>`;
            }
          })
          .join('');

        const date = new Date(review.dateSince).toLocaleDateString("nl-NL", {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        div.innerHTML = `
<div class="stars">${starsHTML}<div class="strtxt">Geverifieerd</div></div>
${content}
<div class="author"><div class="author1">${review.reviewAuthor || "Anoniem"}</div><div>${date}</div></div>
<div class="rating-pill">${review.rating || ""}</div>
        `;
          // Add redirection when the review card is clicked
  div.setAttribute("onclick", "window.location.href='https://www.kiyoh.com/reviews/1079777/hoopo'");


        container.appendChild(div);
      });
    } else {
      container.innerHTML = "<p>Geen beoordelingen gevonden.</p>";
    }
  })
  .catch(() => {
    document.getElementById("reviews").innerHTML = "Fout bij laden van beoordelingen.";
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-bkp"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
